"use client";

import { createContext, useContext } from "react";

const EventVenuePasswordContext = createContext<string>("");

export const EventVenuePasswordProvider = EventVenuePasswordContext.Provider;

/** The validated event venue password, or an empty string when the event venue isn't password gated */
export const useEventVenuePassword = () =>
  useContext(EventVenuePasswordContext);
